import { render, staticRenderFns } from "./PlanIndividual.vue?vue&type=template&id=0cba00e0&scoped=true&"
import script from "./PlanIndividual.vue?vue&type=script&lang=js&"
export * from "./PlanIndividual.vue?vue&type=script&lang=js&"
import style0 from "./PlanIndividual.vue?vue&type=style&index=0&id=0cba00e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cba00e0",
  null
  
)

export default component.exports